import React, { useState, useEffect } from "react"
import Image from "next/image"
import { ChevronRightIcon } from "components/SVG"
import { useSegment } from "tracking"
import type { VariantType } from "@shared/graphql.types"
import {
  shadeSelectorButton,
  viewAllShades,
  activeShadeCopy,
  activeShadeSwatch,
  viewAllShadesCopy,
  shadeCounter,
} from "./ShadeSelector.css"

export type Props = {
  variant: VariantType
  onOpenModal: () => void
  isModalOpen: boolean
}

export const ShadeSelectorButton: React.FC<Props> = ({
  variant,
  onOpenModal,
  isModalOpen = false,
}) => {
  const [activeShade, setActiveShade] = useState<VariantType | null>(null)
  const { track } = useSegment()

  useEffect(() => {
    setActiveShade(variant)
  }, [variant])

  const handleOpenModal = () => {
    onOpenModal()
    track({
      event: "Page Element Clicked",
      properties: {
        module_content: "Shade Selector Button",
        module_content_url: variant?.slug || "",
      },
    })
  }

  return (
    <>
      <p className={shadeCounter}>
        Shades ({variant?.relatedVariants?.length})
      </p>
      <button
        type="button"
        className={shadeSelectorButton}
        onClick={handleOpenModal}
        aria-expanded={isModalOpen}
        aria-controls="shade-selector-modal"
        aria-haspopup="menu"
        data-testid="shade-selector-button"
      >
        <span className={activeShadeCopy}>
          {activeShade?.shadeVisual ? (
            <Image
              src={activeShade?.shadeVisual}
              alt={activeShade?.title}
              height="24"
              width="24"
              className={activeShadeSwatch}
              key={activeShade?.id}
            />
          ) : null}
          {activeShade ? activeShade.subTitle : ""}
        </span>
        <div className={viewAllShades}>
          <span className={viewAllShadesCopy}>View all</span>
          <ChevronRightIcon width="20px" />
        </div>
      </button>
    </>
  )
}
